import Asset from "../../../model/asset/Asset";
import AssetSearch from "../../../model/asset/AssetSearch";

/**
 * Fetch asset successful action.
 */
export const ASSET_FETCHED = "ASSET_FETCHED";
export type ASSET_FETCHED = { asset: Asset }

/**
 * Update asset successful action.
 */
export const ASSET_UPDATED = "ASSET_UPDATED";
export type ASSET_UPDATED = { asset: Asset }

/**
 * Create asset successful action.
 */
export const ASSET_CREATED = "ASSET_CREATED";
export type ASSET_CREATED = { asset: Asset }

/**
 * Fetch asset search successful action.
 */
export const ASSETS_SEARCH_FETCHED = "ASSETS_SEARCH_FETCHED";
export type ASSETS_SEARCH_FETCHED = { assets: AssetSearch[] }